import React from 'react';
import { createComponent } from '@lit/react';

import { MdFilledSelect } from '@material/web/select/filled-select';

import styles from './FilledSelect.module.scss';
import { Text } from '../../text/Text';
import { useTranslation } from 'react-i18next';

const FilledSelectComponent = createComponent({
    tagName: 'md-filled-select',
    elementClass: MdFilledSelect,
    react: React
});

interface IComponentProperties {
    label: string
    required?: boolean | undefined
    supportingText?: string | undefined
    value?: string | undefined,
    children?: React.ReactNode[] | undefined,
}

 /**
   * Max size 1500 items
   */
export function FilledSelect (props: IComponentProperties){

    const { t } = useTranslation();
    return (
        <div className={styles['FilledSelect-container']}>
            <label>
                <Text fontStyle='label-medium' value={props.label}></Text>
            </label>
            <FilledSelectComponent 
                className={styles['FilledSelect']}
                aria-label={t(props.label)}
                required={props.required === true}
                supportingText={t(props.supportingText??'')}
                value={props.value}
                >
                {props.children}
            </FilledSelectComponent>
        </div>
    );

}